import RatingCard from "./RatingCard";

export default RatingCard;
